import { useContext } from "react";
import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import { absencesContext } from '../AbsencesContext';
import { AbsenceTypologyLabel, DeleteIconButton, EditIconButton, NotesIconTooltip } from "components";
import { appUserContext } from "helpers/services";

let Results = () => {
    let service = useContext(absencesContext);
    let appUserService = useContext(appUserContext);

    return (
        <>
            {service.recordCount === 0 &&
                <Typography gutterBottom variant="subtitle2">Nessuna assenza trovata</Typography>
            }
            {service.recordCount > 0 &&
                <>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Utente</TableCell>
                                <TableCell>Tipo di assenza</TableCell>
                                <TableCell>Data Inizio</TableCell>
                                <TableCell>Data Fine</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.absences.map((absence, index) =>
                                <TableRow hover key={index}>
                                    <TableCell>{absence.userLabel}</TableCell>
                                    <TableCell><AbsenceTypologyLabel value={absence.typology} otherTypology={absence.otherTypology} /></TableCell>
                                    <TableCell>{absence.startDate}</TableCell>
                                    <TableCell>{absence.endDate}</TableCell>
                                    <TableCell align="right">
                                        {absence.notes != null && absence.notes !== '' &&
                                            <NotesIconTooltip notes={absence.notes} />

                                        }
                                        {appUserService.currentUser?.simecClaims?.canEditScheduling === true &&
                                            <>
                                                <EditIconButton link={`/absence/edit/${absence.absenceId}`} />
                                                <DeleteIconButton onClick={() => service.deleteAbsence(absence.absenceId)} />
                                            </>
                                        }
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <TablePagination
                        component="div"
                        style={{ padding: 0 }}
                        count={service.recordCount}
                        onPageChange={(e, pageNr) => service.handleChangePage(pageNr)}
                        page={service.search.pageNr}
                        rowsPerPage={service.search.pageSize}
                        rowsPerPageOptions={[service.search.pageSize]}
                        labelDisplayedRows={({ page, count }) =>
                            <>
                                Assenze totali:&nbsp;{count} &nbsp;&middot;&nbsp;
                                <span>Pagina {page + 1} di {Math.ceil(count / service.search.pageSize)}</span>
                            </>
                        }
                    />
                </>
            }
        </>
    )
}

export default Results;